export default {
  onBoarding: '/onboarding',
  onBoardingWithRole: '/onboarding/:role',
  onBoardingV2Agent: '/onboardingv2',
  onBoardingWizard: '/wizard',
  onBoardingWizardWithRole: '/wizard/:role',
  preApprovalWizard: '/wizard/:role/pre-approval',
  onBoardingWizardWithRoleStart: '/wizard/:role/start',
};
